import { AuthenticationClient } from 'authing-js-sdk';
import { environment } from 'src/environments/environment';

export const authingClient = new AuthenticationClient({
    appId: environment.authingAppId,
    appHost: environment.authingAppHost,
});
